import { render, staticRenderFns } from "./ABtn.vue?vue&type=template&id=3d2197c8&"
import script from "./ABtn.vue?vue&type=script&lang=js&"
export * from "./ABtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports